import React, { useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import FuturesPageHeader from '../../pages/markets/pages/options/header';
import JoinOfficialChannels from '../../collection-templates/join-official-channels';
import ResearchReportsAlternate from '../../pages/markets/component/research-reports-alternate';
import FuturesAndOptionsFaq from '../../pages/markets/component/futures-and-options-faq';
import FuturesGraphWidget from '../../pages/markets/component/futures-graph-widget';
import { WithLazy } from '@quintype/components';
import MarketsNewsOptions from '../../pages/markets/component/markets-news-options';
import MostActiveIndexOptions from '../../pages/markets/component/most-active-index-options';
import TopOpenInterestIndexOptions from '../../pages/markets/component/top-open-interest-index-options';
import OpenInterestBreakupOptions from '../../pages/markets/component/open-interest-breakup-options';
import PutCallRatioOptions from '../../pages/markets/component/put-call-ratio-options';
import { makeApiCall } from "../../../helpers/utils";
import { useSelector } from "react-redux";
import get from "lodash/get";
import '../../pages/markets/pages/options/options.m.css';

const OptionChainFull = (props) => {
  const [marketNews, setMarketNews] = useState([]);
  const queryClient = new QueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const NDTV_SEARCH_API_CONFIG = useSelector((state) =>
    get(state, ['qt', 'config', 'integrations', 'aiSummary'], {}),
  );

  useEffect(() => {
    setIsLoading(true);
    makeApiCall(`${NDTV_SEARCH_API_CONFIG?.url}${NDTV_SEARCH_API_CONFIG?.client_key}${NDTV_SEARCH_API_CONFIG?.story_params}&pagesize=15&${NDTV_SEARCH_API_CONFIG?.markets_param}`)
      .then(res => {
        setIsLoading(false);
        setMarketNews(res?.results || []);
      });
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        <div styleName="background-container gap-adjustments">
          <div className="container">
            <FuturesPageHeader {...props} />
          </div>
          <div styleName="container-gap-top-alt container-gap-bottom" className="container">
            <FuturesGraphWidget widget={true} />
          </div>
          <WithLazy>
            {() => (
              <div styleName="background-row" className="container">
                <div>
                  <MostActiveIndexOptions widgetType="index" external={true} widget={true} />
                </div>
                <div styleName="active-stock-container">
                  <MostActiveIndexOptions widgetType="stock" external={true} widget={true} />
                </div>
              </div>
            )}
          </WithLazy>
        </div>
        <WithLazy>
          {() => (
            <div styleName="major-minor-fold gap-adjustments" className="container">
              <MarketsNewsOptions newsData={marketNews} loadingStatus={isLoading} widget={true} />
            </div>
          )}
        </WithLazy>

        <WithLazy>
          {() => (
            <div styleName="major-minor-fold gap-adjustments" className="container">
              <ResearchReportsAlternate widget={true} />
              {!props?.widget && (
                <div>
                  <JoinOfficialChannels sectionName="option-chain-full-widget" />
                </div>
              )}
            </div>
          )}
        </WithLazy>
        <WithLazy>
          {() => (
            <div styleName="background-container">
              <div styleName="gap-adjustments container-gap-top" className="container">
                <TopOpenInterestIndexOptions widget="index" external={true} widgetURL={true} />
              </div>

              <div styleName="gap-adjustments " className="container">
                <TopOpenInterestIndexOptions widget="stock" external={true} widgetURL={true} />
              </div>

              <div styleName="gap-adjustments " className="container">
                <OpenInterestBreakupOptions widget="break-up" external={true} widgetURL={true} />
              </div>

              <div styleName="gap-adjustments " className="container">
                <OpenInterestBreakupOptions widget="expiry" external={true} widgetURL={true} />
              </div>

              <div styleName="gap-adjustments " className="container">
                <PutCallRatioOptions widget={true} />
              </div>

              <div styleName="gap-adjustments  container-gap-bottom" className="container">
                <FuturesAndOptionsFaq widget={true} />
              </div>
            </div>
          )}
        </WithLazy>
      </>
    </QueryClientProvider>
  );
};

export default OptionChainFull;
